import MessagesHome from './MessagesHome';

export default MessagesHome;
